export default __webpack_public_path__ + "static/media/guess-1.79822f4f.svg";